/* Remove share popup handler, let native target=_blank work */
document.addEventListener('DOMContentLoaded', function(){
  setTimeout(function(){
    if (typeof jQuery !== 'undefined') {
      jQuery(document).off('click', '.sharing a');
    }
  }, 500);
});
